// =====================================================================
// REGLAS DE PANTALLA DEL SEGUNDO FACTOR · ESTABILIDAD Parte D
// =====================================================================
// Funciones puras, sin React, para poder probarlas en Node sin montar
// nada. Las pantallas (`AsistenteSegundoFactor`, `NoFuiYo`, `Login`) las
// importan de aquí.

/** Los cuatro pasos del asistente, en orden. */
export const PASOS = ['Qué es', 'Escanea el código', 'Código de prueba', 'Códigos de respaldo'];

/** Deja solo dígitos y como mucho seis: se autocorrige mientras se escribe. */
export function soloDigitos(texto) {
  return (texto || '').replace(/\D/g, '').slice(0, 6);
}

/**
 * Un código de acceso: seis dígitos del autenticador, o uno de respaldo
 * (diez símbolos, con o sin guion). Se limpia de espacios y se pasa a
 * mayúsculas, que es como se imprimen los de respaldo.
 */
export function limpiarCodigo(texto) {
  return (texto || '').replace(/\s+/g, '').toUpperCase().slice(0, 12);
}

export function codigoCompleto(texto) {
  const c = limpiarCodigo(texto);
  return /^\d{6}$/.test(c) || /^[A-Z0-9]{5}-?[A-Z0-9]{5}$/.test(c);
}

/** ¿Se le abre el asistente del segundo factor al entrar? (D1) */
export function debeVerAsistente(usuario, pospuesto) {
  return !!usuario
    && usuario.debe_activar_2fa === true
    && !usuario.debe_cambiar_password
    && usuario.correo_verificado !== false
    && !pospuesto;
}

/** Lee `?ir=no-fui-yo&t=…&c=…`. Lo que no tiene forma se ignora (D5). */
export function datosDelEnlace(busqueda) {
  try {
    const q = new URLSearchParams(busqueda);
    if (q.get('ir') !== 'no-fui-yo') return null;
    const t = (q.get('t') || '').trim();
    const c = Number(q.get('c'));
    if (!/^[A-Za-z0-9_-]{20,200}$/.test(t) || !Number.isInteger(c) || c <= 0) return null;
    return { token: t, empresa: c };
  } catch {
    return null;
  }
}
